import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase";
import { Observable } from "rxjs/Observable";
import { ISponsor } from "../shared/models/sponsor.model";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class PQRData {

    constructor(
        private afDb: AngularFireDatabase,
        private tracking: TrackingProvider,
    ) { }

    public getPqrById(client: string): Observable<ISponsor[]> {
        return this.afDb.list<ISponsor>(`Clients/${client}/UserPQR`).
            valueChanges();
    }

    public setStatusPQR(idItem, clientId, userId, statusPqr) {
        return this.afDb.object(`/Clients/${clientId}/UserPQR/${userId}/${idItem}`).update({
            status: statusPqr,
        });
    }


}
 // end file



// WEBPACK FOOTER //
// ./src/providers/pqr.ts